import Reflux from "reflux";
import URI from "urijs";
import i18n from "i18n";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
export const InputProfilesActions = Reflux.createActions({
  list: { asyncResult: true },
  listAll: { asyncResult: true },
  create: { asyncResult: true },
  get: { asyncResult: true },
  update: { asyncResult: true },
  delete: { asyncResult: true }
});
const InputProfilesStore = Reflux.createStore({
  listenables: [InputProfilesActions],
  sourceUrl: "/plugins/org.graylog.plugins.forwarder/forwarder/profiles",
  inputProfile: void 0,
  all: void 0,
  inputProfiles: void 0,
  pagination: {
    total: 0,
    count: 0,
    page: 1,
    perPage: 10,
    query: ""
  },
  getInitialState() {
    return this.getState();
  },
  getState() {
    return {
      inputProfile: this.inputProfile,
      all: this.all,
      inputProfiles: this.inputProfiles,
      pagination: this.pagination
    };
  },
  propagateUpdate() {
    this.trigger(this.getState());
  },
  _inputProfilesUrl({ segments = [], query = {} }) {
    const uri = new URI(this.sourceUrl);
    const nextSegments = uri.segment().concat(segments);
    uri.segmentCoded(nextSegments);
    uri.query(query);
    return qualifyUrl(uri.resource());
  },
  listAll() {
    const promise = fetch(
      "GET",
      this._inputProfilesUrl({
        query: {
          query: "",
          page: 1,
          per_page: 0
        }
      })
    );
    promise.then(
      (response) => {
        this.all = response.forwarder_input_profiles;
        this.propagateUpdate();
        return response;
      },
      (error) => {
        UserNotification.error(
          i18n.t("notifications.input_profiles_retrieve_failed", { ns: "enterprise_forwarder", error })
        );
      }
    );
    InputProfilesActions.listAll.promise(promise);
  },
  list({ query = "", page = 1, pageSize = 10 }) {
    const promise = fetch(
      "GET",
      this._inputProfilesUrl({
        query: {
          query,
          page,
          per_page: pageSize
        }
      })
    );
    promise.then(
      (response) => {
        this.inputProfiles = response.forwarder_input_profiles;
        this.pagination = {
          total: response.total,
          count: response.count,
          page: response.page,
          perPage: response.per_page,
          query
        };
        this.propagateUpdate();
        return response;
      },
      (error) => {
        UserNotification.error(
          i18n.t("notifications.input_profiles_retrieve_failed", { ns: "enterprise_forwarder", error })
        );
      }
    );
    InputProfilesActions.list.promise(promise);
  },
  create(inputProfile) {
    const promise = fetch("POST", this._inputProfilesUrl({}), inputProfile);
    promise.then(
      (response) => {
        UserNotification.success(i18n.t("notifications.input_profile_created", { ns: "enterprise_forwarder" }));
        this.list({});
        return response;
      },
      (error) => {
        UserNotification.error(
          i18n.t("notifications.input_profile_create_failed", {
            ns: "enterprise_forwarder",
            error,
            title: inputProfile.title
          })
        );
      }
    );
    InputProfilesActions.create.promise(promise);
  },
  get(id) {
    const url = qualifyUrl(`${this.sourceUrl}/${id}`);
    const promise = fetch("GET", url);
    promise.then(
      (response) => {
        this.inputProfile = response;
        this.propagateUpdate();
        return response;
      },
      (error) => {
        UserNotification.error(
          i18n.t("notifications.input_profile_fetch_failed", { ns: "enterprise_forwarder", message: error.message })
        );
      }
    );
    InputProfilesActions.get.promise(promise);
  },
  update(updatedInputProfile, id) {
    const url = qualifyUrl(`${this.sourceUrl}/${id}`);
    const promise = fetch("PUT", url, updatedInputProfile);
    promise.then(
      (response) => {
        this.list({});
        this.get(id);
        UserNotification.success(i18n.t("notifications.input_profile_updated", { ns: "enterprise_forwarder" }));
        return response;
      },
      (error) => {
        UserNotification.error(
          i18n.t("notifications.input_profile_update_failed", {
            ns: "enterprise_forwarder",
            error,
            title: updatedInputProfile.title
          })
        );
      }
    );
    InputProfilesActions.update.promise(promise);
  },
  delete(id) {
    const url = qualifyUrl(`${this.sourceUrl}/${id}`);
    const promise = fetch("DELETE", url);
    promise.then(
      (response) => {
        const nextPage = this.pagination.count !== 1 ? (
          // still has items on page, fetch same page
          this.pagination.page
        ) : (
          // no items left, go to previous page
          this.pagination.page - 1
        );
        this.list({ page: nextPage });
        UserNotification.success(i18n.t("notifications.input_profile_deleted", { ns: "enterprise_forwarder" }));
        return response;
      },
      (error) => {
        UserNotification.error(
          i18n.t("notifications.input_profile_delete_failed", { ns: "enterprise_forwarder", error, id })
        );
      }
    );
    InputProfilesActions.update.promise(promise);
  }
});
export default InputProfilesStore;
